import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Activities } from "../../../components/Activities/Activities";
import { Histories } from "../../../components/Histories/Histories";
import { TabWrapper } from "./CrmTableStyle";
import { OfflineInvoice } from "./OfflineInvoice/OfflineInvoice";
import { OnlineInvoice } from "./OnlineInvoice/OnlineInvoice";
import { useQueryClient } from "react-query";

export const CrmTab = ({ userdata, tags }) => {
  const queryClient = useQueryClient();
  const handleChange = (eventKey) => {
    if (eventKey === "invoice") {
      queryClient.invalidateQueries("get-offline-invoices");
    } else if (eventKey === "online") {
      queryClient.invalidateQueries("get-online-invoices");
    } else if (eventKey === "actions") {
      queryClient.invalidateQueries("crm-data");
    }
  };
  return (
    <TabWrapper>
      <Tabs
        defaultActiveKey="actions"
        id="uncontrolled-tab-example"
        className="mb-3"
        onSelect={(k) => handleChange(k)}
      >
        <Tab eventKey="actions" title="فعالیت ها">
          <Activities userdata={userdata} />
        </Tab>
        <Tab eventKey="history" title="سابقه">
          <Histories userdata={userdata} />
        </Tab>
        <Tab eventKey="invoice" title="فاکتور حضوری">
          <OfflineInvoice userdata={userdata} tags={tags ? tags : ""} />
        </Tab>
        <Tab eventKey="online" title="فاکتور آنلاین">
          <OnlineInvoice userdata={userdata} tags={tags ? tags : ""} />
        </Tab>
      </Tabs>
    </TabWrapper>
  );
};
